import { useAppSelector } from '@store/hooks';
import { getLocalisation } from '@store/localisation';

export const useBrandNameText = () => {
  const { brandNameText } = useAppSelector(getLocalisation);

  return brandNameText;
};
